
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/advanced-search",
      function () {
        return require("private-next-pages/advanced-search.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/advanced-search"])
      });
    }
  